<template>
    <vx-expandable-card>
        <template v-slot:header> Two-Factor Authentication </template>

        <template v-slot:content>
            <div class="flex flex-col gap-6 mt-3">
                <p>
                    In order to use two-factor authentication, you must install the Google Authenticator or any other
                    compatible application on your smartphone.
                </p>
                <vx-button block size="lg" @click.prevent="getCodes" :loading="loading"> Enable </vx-button>
            </div>

            <two-factor-confirmation-modal
                v-model:visible="showModal"
                :twoFactorResetCode="twoFactorResetCode"
                :qrImage="qrImage"
            />
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { ref } from 'vue';
import axios from '~/services/axios';
import { useToasted } from '~/composables/useToasted';
import { VxButton, VxExpandableCard } from '@voxie/frontend-components';
import TwoFactorConfirmationModal from '~/components/settings/security/modals/TwoFactorConfirmationModal.vue';

const toasted = useToasted();
const loading = ref(false);
const showModal = ref(false);

const twoFactorResetCode = defineModel('twoFactorResetCode');
const qrImage = defineModel('qrImage');

const getCodes = async () => {
    if (loading.value) {
        return;
    }

    try {
        loading.value = true;

        if (!twoFactorResetCode.value || !qrImage.value) {
            const response = await axios.get('/settings/two-factor-auth/codes');

            twoFactorResetCode.value = response.data.resetCode;
            qrImage.value = response.data.qrCode;
        }

        showModal.value = true;
    } catch (e) {
        console.error(e);
        toasted.global.platform_error();
    } finally {
        loading.value = false;
    }
};
</script>
